module.exports = __webpack_public_path__ + "static/media/AB_N1_9.16a37759.jpg";